import { render } from "./wButtonSave.vue?vue&type=template&id=58d27017&ts=true"
import script from "./wButtonSave.vue?vue&type=script&lang=ts"
export * from "./wButtonSave.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__